import React, { useEffect } from 'react';

import FinalProduct from '../FinalProduct/FinalProduct';
import { TextWithTagToBr } from '../../../components/common/molecules/TextWithTagToBr';
import { babyface } from '../../../lib/image/CDNUrl';
import * as PATH from '../../../lib/routes/path';
import { Text } from '../../../components/common/atom/Text';
import { Flex } from '../../../components/common/atom/Layout';
import { TextLink } from '../../../components/common/molecules/TextLink';
import { HorizonGreyLine } from '../../../components/common/atom/HorizonGreyLine';
import { Anchor } from '../../../components/common/atom/Anchor';
import { VerticalPadding } from '../../../components/common/atom/Padding';
import styled from 'styled-components';

function doShowTextArea(text) {
  return (
    <Flex column padding="0 0 1.25rem 0">
      <Text size={14} weight="medium" style={{ margin: '0.625rem 0' }}>
        베이비페이스 팀의 메시지
      </Text>
      <Flex
        column
        alignItems="flex-start"
        padding="0.625rem"
        style={{
          background: '#fff7f6',
          borderTop: '1px solid #929292',
          fontSize: '0.75rem',
        }}
      >
        {TextWithTagToBr(text)}
      </Flex>
    </Flex>
  );
}

function doShowFriendPayback(shippingToAffiliate) {
  return (
    <>
      {!shippingToAffiliate &&
        PAYBACKLINK.map((item, idx) => (
          <Flex
            key={item.title}
            justifyContent="space-between"
            style={{ borderBottom: '1px solid #929292' }}
            padding="2rem 0 0.125rem"
          >
            <Text size={14} weight="medium">
              {item.title}
            </Text>
            <TextLink link={item.link} size={14} color="orangePink">
              최대 {item.price}원 받으러 가기 {'>'}
            </TextLink>
          </Flex>
        ))}
      {shippingToAffiliate ? (
        <>
          <VerticalPadding padding={10}>
            <Text size={12} lineHeight="1.25rem" weight="medium">
              상품이 마음에 드셨나요? 친구에게 추천해주세요!
            </Text>
          </VerticalPadding>
          <Text size={12}>
            추천코드를 사용하여, 친구는 3000원을 할인 받을 수 있습니다.
            <br />* 친구추천코드를 통한 초대 및 사용은 제한이 없습니다.
            <br />* <b>상품권을 통해 신청한 고객</b>은 페이백을 받을 수
            없습니다.
          </Text>
        </>
      ) : (
        <>
          <VerticalPadding padding={16}>
            <Text size={12} lineHeight="1rem" weight="medium">
              상품이 마음에 드셨나요? 친구에게 추천해주세요! 
              <br /><b>첫 친구는 특별히, 나와 친구 모두 5,000원 혜택</b>
              <br /><b>이후 친구는, 나와 친구 모두 3,000원 혜택!</b>
            </Text>
          </VerticalPadding>
          <Ulist>
            <List>친구추천코드를 통한 초대 및 사용은 제한이 없습니다.</List>
            <List>페이백은 최대 8,000원까지만 가능합니다.</List>
            <List>친구가 추천코드를 사용 후 변환완료 단계가 되면 자동으로 페이백 됩니다.</List>
            <List>페이백은 결제하신 방법으로 환불됩니다.</List>
          </Ulist>
        </>
      )}
    </>
  );
}

const ItemResultView = ({ data }) => {
  const itemResult = { ...data };

  useEffect(() => {}, [data]);
  const SnowUrl = 'https://snow.onelink.me/4056789859/9b4371a6';
  const snowXBabyfaceImageDesktop = `${babyface}/event/snow_babyface_pc.png`;

  return (
    <>
      <FinalProduct id={itemResult.id} />

      {doShowTextArea(itemResult.inspectorMessage)}
      <HorizonGreyLine />
      {doShowFriendPayback(itemResult.shippingToAffiliate)}
    </>
  );
};

export default React.memo(ItemResultView);

const PAYBACKLINK = [
  {
    title: '리뷰 작성',
    price: '1,000',
    link: PATH.MYPAGE_REVIEW,
  },
  {
    title: '친구 초대',
    price: '8,000',
    link: PATH.MYPAGE_PAYBACK,
  },
];

const Ulist = styled.ul`
  margin-top: 0;
  padding-left: 1.25rem;
`;

const List = styled.li`
  font-size: 0.75rem;
  line-height: 1.25rem;
`;